<div class="seatbelt dark-belt">

    <div class="site-gutter">
        <div class="wrapper">
            <p>{{copy}}</p>
            @if (buttonUrl) {
                @if (urlFragment) {
                    <a routerLink="{{buttonUrl}}" fragment="{{urlFragment}}" class="button">{{buttonText}}</a>
                } @else {
                    <a routerLink="{{buttonUrl}}" class="button">{{buttonText}}</a>
                }
            }
        </div>
    </div>
</div>